import { Formik } from 'formik'
import React, { useEffect, useState,  } from 'react'
import * as yup from 'yup'
import { api } from '../../../utils'
import _ from 'lodash'
import useTrans from '../../../hooks/useTrans'
import { Button, FormField } from '../../atoms'
import FormInput from '../../atoms/FormInput/FormInput'
import { GET_PROMO_CODE, REMOVE_PROMO_CODE, SET_PROMO_CODE } from '../../../utils/endpoint'
import Accordion from '../../atoms/Accordion/Accordion'


api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'


// COMPONENTE NON USATO
const PromoCodeForm = ({ ordine }) => {
    const t = useTrans()

    const [codice, setCodice] = useState()
    const [open, setOpen] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [confermaApplicazione, setConfermaApplicazione] = useState(undefined)

    useEffect(() => {
        getPromoCode()
    }, [])

    useEffect(() => {
        if(ordine.promozioni_applicate) {
            if(ordine?.promozioni_applicate?.length > 0) {
                setConfermaApplicazione(true)
            } else {
                setConfermaApplicazione(false)
            }
        } else {
            setConfermaApplicazione(undefined)
        }
    }, [ordine])

    const validationSchema = yup.object().shape({
        codice: yup.string().required(t('Campo obbligatorio')),
    })

    const initialValues = {
        codice: codice || '',
    }

    const getPromoCode = async () => {
        await api
        .get(GET_PROMO_CODE)
        .then((res) => {
            setCodice(res?.data)
            setOpen(true)
            setSuccess(true)
        })
        .catch((err) => {
            setCodice(null)
        })
    }

    const setPromoCode = async (codice) => {
        try {
            const response = await api.post(SET_PROMO_CODE, { "promo_code": codice })
            setSuccess(true)
            setError(false)
            setConfermaApplicazione(undefined)
            getPromoCode()
        }
        catch(err) {
            setSuccess(false)
            setError(true)
            setCodice(null)
            setConfermaApplicazione(undefined)
        }
    }

    const removePromoCode = async (codice) => {
        try {
            const response = await api.post(REMOVE_PROMO_CODE)
            setSuccess(true)
            setError(false)
            setConfermaApplicazione(undefined)
            getPromoCode()
        }
        catch(err) {
            setSuccess(false)
            setError(true)
            setCodice(null)
            setConfermaApplicazione(undefined)
        }
      }

    return (
        <Accordion
            withoutBorder
            placeholder={t('Codice sconto')}
            size="medium"
            placeholderEllipses={true}
            defaultOpen={open ? true : false}
        >
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    setPromoCode(values.codice)
                }}
                validationSchema={validationSchema}
            >
            {({ values, touched, errors, handleBlur, handleChange, handleSubmit }) => (
                
                <div className="promo-code-form__container">
                    <FormField
                        status={
                        touched.codice && errors.codice
                            ? 'error'
                            : touched.codice && ''
                        }
                        errorMessage={errors?.codice}
                    >
                        <FormInput
                            disabled={codice}
                            placeholder= {t('Inserisci codice')}
                            value={values.codice}
                            onBlur={handleBlur('codice')}
                            onChange={handleChange('codice')}
                        />
                    </FormField>
                    {!confermaApplicazione &&
                    <div className="promo-code-form__alert">
                        <p>{t("Attenzione: lo sconto verrà applicato dopo la conferma del metodo di pagamento")}</p>
                    </div>
                    }
                    {/* {success && (
                        <div className="promo-code-form__success">
                        <p>
                            {t('Il codice è stato applicato al tuo ordine')}
                            <span className="promo-code-form__success__info">
                                <Tooltip
                                    label={t(
                                        'Conferma il pagamento per aggiornare gli importi dell\'ordine'
                                    )}
                                >
                                    <Info />
                                </Tooltip>
                            </span>
                        </p>
                        </div>
                    )} */}
                    {/* {error && (
                        <div className="promo-code-form__error">
                        <span>{t('Il codice inserito non è valido')}</span>
                        </div>
                    )} */}
                    {confermaApplicazione === true ?
                        <div className="promo-code-form__success">
                            <span>{t('Il codice sconto è stato applicato al tuo ordine')}</span>
                        </div>
                    : confermaApplicazione === false &&
                        <div className="promo-code-form__error">
                            <span>{t('Non è possible applicare il codice sconto al tuo ordine')}</span>
                        </div>
                    }
                    {codice ? (
                    <Button
                        type="button"
                        size="small"
                        variant="primary"
                        label={t('Rimuovi')}
                        onClick={() => removePromoCode(values?.codice)}
                    />
                    ) : (
                    <Button
                        type="submit"
                        size="small"
                        variant="primary"
                        label={t('Inserisci')}
                        disabled={!values?.codice?.length}
                        onClick={handleSubmit}
                    />
                    )}
                </div>
            )}
            </Formik>
        </Accordion>
    )
}

export default PromoCodeForm